import DocumentTitle from 'react-document-title'
import Games from './Games'
import Introduction from './Introduction'
import React from 'react'
import Team from './Team'

class Home extends React.Component {
  render() {
    return(
      <DocumentTitle title="BurzNest LLC">
        <main className="container">
          <center>
            <img src="/images/logo.png" role="presentation" />
          </center>
          <div className="content is-medium">
            <div className="field">
              <Introduction />
            </div>
            <br />
            <div className="field">
              <Games />
            </div>
            <br />
            <div className="field">
              <Team />
            </div>
          </div>
        </main>
      </DocumentTitle>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/Home.js